module.exports = __webpack_public_path__ + "static/img/Search failure@2x.0b06910.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/Search failure@2x.png
// module id = 482
// module chunks = 1